import Http from '@services/Http';
import { EMBRION_API_URL } from '@/data/enviroment';

export default {
  async login(data) {
    return Http(EMBRION_API_URL).post('/login', data);
  },
};
